import React, { Component } from "react";
import { DownloadTableExcel } from "react-export-table-to-excel";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../../../components/CustomComponent.js";
import {reports} from "../../../components/Report.js";
export default class WithdrawalGoods extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_detail: false,
      modal_serialno: false,

      filter_search: "",
      filter_product_id: "",
      filter_warehouse_id: "",
      filter_destination_warehouse_id: "",
      filter_category_id: "",
      filter_company_id: "",
      filter_start_date: "",
      filter_end_date: "",
      filter_activity_type: "",
      filter_status: "",
      filter_user_id: "",

      product_qrcode: "",
      product_index: -1,
      serial_list: [],

      data: [],
      count: 0,
      data_user: [],
      data_warehouse: [],
      data_company: [],
      data_product: [],
      data_category: [],
      data_repair: [],

      // stock
      document_no: "",
      repair_id: params("repair_id") || "",
      type: "",
      name: "",
      date: format_date(new Date(), "yyyy-mm-dd", "en"),
      start_date: "",
      end_date: "",
      count_item: "",
      ref_number: "",
      activity_type: "เบิกเพื่อซ่อม",
      customer_id: "",
      supplier_id: "",
      warehouse_id: "",
      destination_warehouse_id: params("warehouse_id") || "",
      user_id: "",
      amount: "",
      discount: "",
      vat: "",
      amount_net: "",
      cause: "",
      status: "",
      remark: "",
      transaction_list: [],
      is_refund: false,

      // สินค้า
      photo: "",
      product_warehouse_id: "",
      product_code: "",
      product_name: "",
      category_id: "",
      unit_name: "",
      sale_price: "",
      cost_price: "",
      product_description: "",

      is_vat: false,
      delivery_cost: "",

      detail: null,
    };
    this.tableRef = React.createRef();
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }

  Get = async (page) => {
    const {
      filter_search,
      filter_start_date,
      filter_end_date,
      filter_warehouse_id,
      filter_destination_warehouse_id,
      filter_company_id,
      filter_status,
      filter_activity_type,
      destination_warehouse_id,
    } = this.state;
    loading(true);
    let data,
      count,
      data_warehouse
    let [
      result,
      result_warehouse,
    ] = await Promise.all([
      GET("admin/stock-activities/list", {
        page: 0,
        page_size: 10000,
        data_search: filter_search,
        start_date: filter_start_date,
        end_date: filter_end_date,
        warehouse_id: filter_warehouse_id,
        destination_warehouse_id: filter_destination_warehouse_id,
        supplier_id: filter_company_id,
        status_code: filter_status,
        activity_type: filter_activity_type,
        type: "เบิกสินค้า",
      }),
      GET("admin/setting/warehouses/list", { page: 0, data_search: "" }),
    ]);
    if (result?.status) {
      data = result.data;
      let result_product = await Promise.all(data.map((e) => GET("admin/stock-activities/list", { uid: e.uid })));
            data = result_product.flatMap(e =>
  e.data.transaction_list.map(t => ({ ...t, data: e.data }))
);

    }
    if (result_warehouse?.status) {
      data_warehouse = result_warehouse.data.map((e) => ({
        value: e.uid,
        label: e.name,
      }));
    }
    this.setState({
      data,
      count,
      data_warehouse,
    });
    loading(false);
  };

    ExportPDF = async () => {
      const table = this.tableRef.current;
      if (!table) return [];
  
      const rows = Array.from(table.querySelectorAll("tbody tr"));
  
      const data_list = rows.map((tr) => {
        const cells = Array.from(tr.querySelectorAll("td"));
        return cells.map((td) => td.innerText.trim());
      });
  
      const obj = {
            table: {
              headerRows: 1,
              widths: ["auto","auto","auto","*","auto","auto","auto","auto","auto","auto","auto"],
              body: [
                [
                  { text: "วันที่เบิก", alignment: "center" },
                  { text: "เลขที่ใบเบิก", alignment: "center" },
                  { text: "รหัสอะไหล่", alignment: "center" },
                  { text: "ชื่ออะไหล่", alignment: "left" },
                  { text: "Serial No.", alignment: "center" },
                  { text: "จำนวน", alignment: "center" },
                  { text: "หน่วย", alignment: "center" },
                  { text: "จากโกดัง", alignment: "center" },
                  { text: "ไปโกดัง", alignment: "center" },
                  { text: "ใบแจ้งซ่อม", alignment: "center" },
                  { text: "หมายเหตุ", alignment: "center" },
                ],
                ...data_list.map((item, index) => {
                  let border = [1, 0, 1, 0];
                  let color = "#ffffff";
                  return [
                      { text: item[0], alignment: "center", fillColor: color, border },
                      { text: item[1], alignment: "center", fillColor: color, border },
                      { text: item[2], alignment: "center", fillColor: color, border },
                      { text: item[3], alignment: "left", fillColor: color, border },
                      { text: item[4], alignment: "center", fillColor: color, border },
                      { text: item[5], alignment: "center", fillColor: color, border },
                      { text: item[6], alignment: "center", fillColor: color, border },
                      { text: item[7], alignment: "left", fillColor: color, border, noWrap: true },
                      { text: item[8], alignment: "left", fillColor: color, border, noWrap: true },
                      { text: item[9], alignment: "center", fillColor: color, border },
                      { text: item[10], alignment: "left", fillColor: color, border },
                    ]
                  }
              ),
                [
                      { text: " ", border: [1, 0, 1, 1], fontSize:2 },
                      { text: " ", border: [1, 0, 1, 1], fontSize:2 },
                      { text: " ", border: [1, 0, 1, 1], fontSize:2 },
                      { text: " ", border: [1, 0, 1, 1], fontSize:2 },
                      { text: " ", border: [1, 0, 1, 1], fontSize:2 },
                      { text: " ", border: [1, 0, 1, 1], fontSize:2 },
                      { text: " ", border: [1, 0, 1, 1], fontSize:2 },
                      { text: " ", border: [1, 0, 1, 1], fontSize:2 },
                      { text: " ", border: [1, 0, 1, 1], fontSize:2 },
                      { text: " ", border: [1, 0, 1, 1], fontSize:2 },
                      { text: " ", border: [1, 0, 1, 1], fontSize:2 },
                    ]
              ],
            },
          };
      reports("รายงานเบิกสินค้าระหว่างโกดัง", obj,12);
    }
  render() {
    const {
      filter_search,
      filter_product_id,
      filter_warehouse_id,
      filter_destination_warehouse_id,
      filter_category_id,
      filter_start_date,
      filter_end_date,
      filter_activity_type,
      filter_status,
      filter_user_id,

      data,
      data_warehouse,
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="body p-3">
          <div className="rounded-4 bg-white p-3">
            <div className="d-flex justify-content-between flex-wrap mb-3">
              <h4 className="fw-bold mb-3 me-3">รายงานเบิกสินค้าระหว่างโกดัง</h4>
            </div>
            <div>
              <div className="d-flex align-items-center flex-wrap">
                <input
                  type="text"
                  className="form-control wpx-200 me-2 mb-2"
                  placeholder="ค้นหา ใบเบิกสินค้า ,ใบแจ้งซ่อม..."
                  onChange={(e) => {
                    this.setState({ filter_search: e.target.value });
                  }}
                  onKeyUp={(e) => {
                    if (e.key === "Enter") {
                      this.Get(1);
                    }
                  }}
                  value={filter_search}
                />
                <input
                  type="date"
                  className="form-control wpx-200 me-2 mb-2"
                  onChange={(e) => {
                    this.setState({ filter_start_date: e.target.value });
                  }}
                  value={filter_start_date}
                />
                <span className="px-2 me-2 mb-2">ถึง</span>
                <input
                  type="date"
                  className="form-control wpx-200 me-2 mb-2"
                  onChange={(e) => {
                    this.setState({ filter_end_date: e.target.value });
                  }}
                  value={filter_end_date}
                />
                <select
                  className="form-control wpx-200 me-2 mb-2"
                  onChange={(e) => {
                    this.setState({ filter_activity_type: e.target.value });
                  }}
                  value={filter_activity_type}
                >
                  <option value="">ประเภทการเบิก</option>
                  <option value="เบิกเพื่อซ่อม">เบิกเพื่อซ่อม</option>
                  <option value="เบิกย้ายโกดัง">เบิกย้ายโกดัง</option>
                </select>
                <select
                  className="form-control wpx-200 me-2 mb-2"
                  onChange={(e) => {
                    this.setState({ filter_status: e.target.value });
                  }}
                  value={filter_status}
                >
                  <option value="">สถานะ</option>
                  <option value="เสร็จสิ้น">เสร็จสิ้น</option>
                  <option value="ยกเลิก">ยกเลิก</option>
                </select> 
                <div className="wpx-200 me-2 mb-2">
                  <Select
                    className="form-control"
                    placeholder="คลังสินค้าต้นทาง..."
                    options={data_warehouse}
                    onChange={(e) => {
                      this.setState({ filter_warehouse_id: e });
                    }}
                    value={filter_warehouse_id}
                  />
                </div>
                <div className="wpx-200 me-2 mb-2">
                  <Select
                    className="form-control"
                    placeholder="คลังสินค้าปลายทาง..."
                    options={data_warehouse}
                    onChange={(e) => {
                      this.setState({ filter_destination_warehouse_id: e });
                    }}
                    value={filter_destination_warehouse_id}
                  />
                </div>
                <div className="d-flex">
                  <button
                    className="btn btn-dark px-3 me-2 mb-2"
                    onClick={() => {
                      this.Get(1);
                    }}
                  >
                    ค้นหา
                  </button>
                  <button
                    className="btn btn-outline-dark px-3 me-2 mb-2"
                    onClick={() => {
                      this.setState({
                        filter_search: "",
                        filter_receive_date: "",
                        filter_warehouse_id: "",
                        filter_company_id: "",
                        filter_category_id: "",
                        filter_status: "",
                        filter_start_date: "",
                        filter_end_date: "",
                        filter_activity_type: "",
                      });
                      setTimeout(() => {
                        this.Get(1);
                      }, 100);
                    }}
                  >
                    ล้างค่า
                  </button>
                </div>
              <div className="ms-auto">
                <button className="btn btn-warning px-3 mb-2 me-2" onClick={()=>this.ExportPDF()}>Export PDF</button>
                <DownloadTableExcel
                  filename="รายงานเบิกสินค้าระหว่างโกดัง"
                  sheet="รายงานเบิกสินค้าระหว่างโกดัง"
                  currentTableRef={this.tableRef.current}
                >
                  <button className="btn btn-warning px-3 mb-2">Excel</button>
                </DownloadTableExcel>
              </div>
              </div>
              <div className="table-responsive" style={{maxHeight:"70vh"}}>
                <table className="table rounded-3 overflow-hidden table-hover"
                ref={this.tableRef}>
                  <thead>
                    <tr>
                      <td className="text-nowrap">วันที่เบิก</td>
                      <td className="text-nowrap">เลขที่ใบเบิก</td>
                      <td className="text-nowrap">รหัสอะไหล่</td>
                      <td className="text-nowrap">ชื่ออะไหล่</td>
                      <td className="text-nowrap">Serial No.</td>
                      <td className="text-nowrap">จำนวน</td>
                      <td className="text-nowrap">หน่วย</td>
                      <td className="text-nowrap">จากโกดัง</td>
                      <td className="text-nowrap">ไปโกดัง</td>
                      <td className="text-nowrap">ใบแจ้งซ่อมที่เกี่ยวข้อง</td>
                      <td className="text-nowrap">หมายเหตุ</td>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.filter(item=>!filter_search || (item.product_code + item.product_name).includes(filter_search)).map((item, index) => (
                      <tr>
                        <td className="text-nowrap">{item.created_at ? format_date(item.created_at) : "-"}</td>
                        <td className="text-nowrap">{item.data?.document_no || "-"}</td>
                        <td className="text-nowrap">{item.product_code || "-"}</td>
                        <td className="text-nowrap">{item.product_name || "-"}</td>
                        <td className="text-nowrap">{item.serial_number.toString() || "-"}</td>
                        <td className="text-nowrap">{item.qty || "-"}</td>
                        <td className="text-nowrap">{item.unit_name || "-"}</td>
                        <td className="text-nowrap">{item.data?.warehouse?.name || "-"}</td>
                        <td className="text-nowrap">{item.data?.destination_warehouse?.name || "-"}</td>
                        <td className="text-nowrap">{item.data?.repair?.document_no || "-"}</td>
                        <td className="text-nowrap">{item.data?.remark || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div> 
            </div>
          </div>
        </div>
      </div>
    );
  }
}
